@use '@design/design-tokens/typography/typography' as *;

.styledInput {
  [data-input-right-icon] {
    @include typography-v2-body-base;

    color: var(--text-soft);
  }
}
